import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const CLIENT_ID_PREFIX = 'rovo-broadcast-confirmed-actions';

/**
 * Generates a client ID for Rovo broadcast confirmed actions by appending the provided ID
 * to a predefined client ID prefix.
 *
 * @param id - The unique identifier to append to the client ID prefix.
 * @returns The constructed client ID string for the Rovo broadcast confirmed actions client.
 */
export const getRovoBroadcastConfirmedActionsClientId = (id: string): ClientId =>
	client(`${CLIENT_ID_PREFIX}-${id}`);

/**
 * Determines if the provided client ID belongs to a Rovo Broadcast Confirmed Actions client. Useful to filter broadcast recipients.
 *
 * @param clientId - The client ID to check.
 * @returns `true` if the client ID starts with the expected prefix for Rovo Broadcast Confirmed Actions; otherwise, `false`.
 */
export function isRovoBroadcastConfirmedActions(clientId: ClientId): boolean {
	return clientId.startsWith(CLIENT_ID_PREFIX);
}
